
<template>
  <div class="cbody1">

      <div class="jisoshi">
    <div class="jsbox">
        <img :src="bgimg" alt="" class="icon">
         <div class="tbox">
             <p class="p1">
                ALL ABOUT LUX</p>
             <p class="p2">{{about}}</p>
         </div>
    </div>
    <div class="tuijian">
 
         <div class="tjlist" v-for="(item,index) in listData" :key="item.id">
          <img :src="item.content.img" alt="" class="icon">
          <div class="tbox">
           
             <p class="p2">{{item.name}}</p>
             <p class="p3">{{item.content.subtitle}}</p>
          </div>
       </div>


    </div>
 </div>
 </div>
</template>

<script>
import { Recommend,settings} from '../../api/userMG'

import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css'
export default {
name:'recommend',
data() {
  return {
    about:'',
    bgimg:require("@/assets/img/bg6.jpg"),
      webname:'nomomo',
    webkey:'激光脫毛</br>​激光祛斑祛印',
    listData:[],
   

    params:{
      mt_id:2
    }
  }
},
// 註冊組件
components: {


  
},
/**
 * 數據發生改變
 */

/**
 * 創建完畢
 */
created() {

},
mounted() {
  this.getdata(this.params)
  this.getdata2('about')
new WOW.WOW().init();
},
/**
 * 裏麵的方法隻有被調用才會執行
 */
methods: {
  getdata2(parameter) {

  
  

settings(parameter)
.then(res => {
  this.loading = false

  if (res.data.code != 1) {
    this.$message({
      type: 'info',
      message: res.message
    })
  } else {
      let dd=res.data.data.data
    if(dd.length>0){
      let path=JSON.parse(dd[0].content)['val']

      this[parameter]=path
   
    }
 
     
  }
})
.catch(err => {
  this.loading = false
  this.$message.error('菜單加載失敗，請稍後再試！')
})
},
  // 獲取公司列錶
  getdata(params) {
    this.loading = true
  

    /***
     * 調用接口，註釋上麵模擬數據 取消下麵註釋
     */
     Recommend(params)
      .then(res => {
        this.loading = false
  
        if (res.data.code != 1) {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        } else {
          res.data.data.data.forEach(el => {
            el.content=JSON.parse(el.content)
        
          });
          this.listData = res.data.data.data

        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  }

 
}
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/home/recommend.vue